export default "__VITE_ASSET__Nev845u5__"